import { Component, OnInit, signal } from '@angular/core';

// 1. Structure de données propre et lisible (Fini les split() capricieux)
const VIDEOS = [
  { id: 'sgxcjDKPAgg', name: 'V-NEM Introduction' },
  { id: 'JMN39w4qebI', name: 'Regional NEM' },
  { id: '6bjz1zltRt4', name: 'NEM Generators Tab' },
  { id: 'NF_xLa1Sl7I', name: 'NEM VWAP (Volume Weighted Average Price)' },
  { id: 'gXGhUstlsEA', name: 'Renewables summary' },
  { id: 'oBY4KX_ebJ8', name: 'Interconnector Data' }
];

@Component({
  selector: 'nem-yt-video',
  standalone: false,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    // Rend le composant bloc et flexible pour le parent
    class: 'block w-full h-full'
  },
  template: `
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 h-full text-slate-200 p-2 md:p-6">
      <div class="flex flex-col h-full">
        <h2 class="mb-8 text-center text-lg md:text-xl font-medium text-indigo-200/80 px-4 leading-relaxed">
          The following URLs introduce you to the dashboard through YouTube clips
        </h2>

        <ul role="list" class="flex flex-col gap-3 flex-1 overflow-y-auto pr-2 custombar">
          @for (vd of videos; track vd.id) {

          <li
            (click)="play(vd.id)"
            class="group relative flex items-center justify-between py-4 px-5 rounded-xl border transition-all duration-300 cursor-pointer overflow-hidden"
            [ngClass]="{
              'bg-[#2d2459] border-[#6d28d9] text-white shadow-[0_0_20px_rgba(109,40,217,0.3)]': selectedId() === vd.id,
              'bg-white/5 border-white/10 text-slate-400 hover:bg-white/10 hover:text-slate-200': selectedId() !== vd.id
            }">
            @if (selectedId() === vd.id) {
            <div class="absolute left-0 top-0 bottom-0 w-1 bg-[#a78bfa] shadow-[0_0_10px_#a78bfa]"></div>
            }

            <div class="flex w-0 flex-1 items-center gap-4">
              <i
                class="pi text-lg transition-transform duration-300 group-hover:scale-110"
                [ngClass]="
                  selectedId() === vd.id
                    ? 'pi-play-circle text-[#a78bfa]'
                    : 'pi-video text-slate-500 group-hover:text-slate-300'
                ">
              </i>

              <span class="truncate font-medium tracking-wide transition-colors">
                {{ vd.name }}
              </span>
            </div>
          </li>
          }
        </ul>
      </div>

      <div
        class="lg:col-span-2 relative w-full rounded-2xl overflow-hidden bg-black shadow-2xl ring-1 ring-white/10 flex items-center justify-center">
        <div class="w-full aspect-video">
          <youtube-player [videoId]="selectedId()" [playerVars]="playerVars" width="100%" height="100%">
          </youtube-player>
        </div>
      </div>
    </div>
  `
})
export class YtVideoComponent implements OnInit {
  videos = VIDEOS;

  // Utilisation d'un Signal pour l'état sélectionné
  selectedId = signal<string>(this.videos[0].id);

  // Configuration propre du player
  playerVars: YT.PlayerVars = {
    enablejsapi: 1,
    rel: 0, // Désactive les vidéos suggérées d'autres chaînes à la fin
    modestbranding: 1 // Masque le logo YouTube encombrant
  };

  play(id: string) {
    this.selectedId.set(id);
  }

  ngOnInit() {
    // Vérifie si le script YT est déjà chargé (évite de l'ajouter plusieurs fois si on change de page)
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
    }
  }
}
